import React, { useState } from "react";

const LoyaltyBalance = ({ profile }) => {

    const [isHovered1, setIsHovered1] = useState(false);
    const [isHovered2, setIsHovered2] = useState(false);

    return (
        <div className="min-h-[370px] xl:h-auto h-full py-[16px] px-[20px] rounded-[15px] md:mb-0 mb-[20px]"
            style={{
                backgroundColor: '#fff'
            }}>
            <div className="flex xl:flex-row flex-row sm:flex-col justify-between items-center xl:gap-[15px]">
                <div>
                    <div className="font-semibold sm:text-[20px] text-[18px] xl:text-start  text-start sm:text-center">
                        Баланс
                    </div>
                    <div className="font-normal min-w-[135px]">
                        <span className="xl:text-[36px] text-[30px]" style={{ color: '#C3372E' }}>{profile.bonuspoints} </span> баллов
                    </div>
                </div>
                <div>
                    <button className="xl:text-[16px] text-[14px] py-4 px-4 border-solid border-[1px] rounded-[35px] transition duration-300"
                        style={{
                            color: isHovered1 ? '#fff' : '#C3372E',
                            backgroundColor: isHovered1 ? '#C3372E' : '',
                            borderColor: '#C3372E'
                        }}
                        onMouseEnter={() => setIsHovered1(true)}
                        onMouseLeave={() => setIsHovered1(false)}
                    >
                        ИСПОЛЬЗОВАТЬ
                    </button>
                </div>
            </div>

            <div className="w-full mt-[5px] leading-[1.3] p-[15px] border-[1px] border-dashed rounded-[15px]"
                style={{
                    borderColor: '#C3372E'
                }}>
                <div className="flex items-center gap-[7px] justify-between mb-[5px]">
                    <div className="sm:text-[16px] text-[14px] font-semibold w-[80%]">
                        Двойные баллы за заказы до 31 декабря!
                    </div>
                    <div className="w-[35px]">
                        <img className="w-[35px]" src="/img/lk/lkLoyalty/bet.svg" />
                    </div>
                </div>
                <div className="border-b-[1px] border-dashed sm:text-[14px] text-[12px] pb-[6px]"
                    style={{
                        borderColor: '#C3372E'
                    }}>
                    Сделайте заказ до 31 декабря и получите в 2 раза больше бонусов
                </div>
                <div className="w-full pt-[6px]">
                    <div className="font-semibold text-[16px] mb-[6px]">
                        Последняя заявка
                    </div>
                    <div className="flex items-center justify-between mb-[5px] text-[14px]"
                        style={{
                            color: '#626C75'
                        }}>
                        <div>Пекин</div>
                        <div>Гонконг</div>
                    </div>
                    <div className="w-[100%] xl:flex hidden items-center">
                        <img src="/img/lk/lkLoyalty/dorogaKrug.svg" />
                        <img className="flex-grow w-auto" src="/img/lk/lkLoyalty/dorogaPunctir.svg" />
                        <img src="/img/lk/lkLoyalty/dorogaKrug.svg" />
                    </div>
                    <div className="xl:hidden block w-[100%]" >
                        <img className="w-full" src="/img/lk/lkLoyalty/dorogafull.svg" />
                    </div>
                </div>
            </div>

            <div className="my-[7px] text-center">
                <span className="text-[24px]" style={{
                    color: '#C3372E'
                }}>380 </span> баллов х2
            </div>

            <div className="w-full">
                <button className="w-full rounded-[35px] uppercase py-4 font-bold text-[14px] transition duration-300" style={{
                    color: '#fff',
                    backgroundColor: isHovered2 ? '#A32A25' : '#C3372E',
                }}
                    onMouseEnter={() => setIsHovered2(true)}
                    onMouseLeave={() => setIsHovered2(false)}>
                    Создать новую
                </button>
            </div>
        </div>
    )
}

export default LoyaltyBalance;
